import {
  convertDigitToProperFormat,
  convertNumbersToProperFormat,
} from '../../../../utils/number';
import moment from 'moment-jalaali';
import { Term } from '../../../../store/pdp/types';
import { getLanguageBaseOnTZ } from '../../../../utils/LanguageLocalStorage';

export default {
  today: 'امروز',
  correctiveClass: 'دوره اصلاحی',
  month: 'ماه',
  week: 'هفته',
  next: '',
  back: 'قبلی',
  effectivity: 'نرخ یادگیری',
  enabled: 'فعال سازی',
  pdpSatusReview: 'وضعیت نیازسنجی کاربر',
  ForEver: 'اسناد در صورت فعال بودن فاز قابل مشاهده هستند',
  DuringPhase:
    'اسناد تنها در بازه مشخص شده و به شرط فعال بودن فاز قابل مشاهده هستند',
  phaseDocuments: 'اسناد فاز',
  default: 'پیشفرض',
  contentVisible: 'بازه قابل رویت اسناد',
  startDate: 'تاریخ شروع',
  endDate: 'تاریخ پایان',
  save: 'ذخیره',
  Attended: 'نامشخص',
  NotAttended: 'عدم شرکت',
  Approved: 'قبول شده',
  Rejected: 'رد شده',
  Dropped: 'لغو شرکت',
  participant: 'شرکت کننده',
  approved: 'قبول شده',
  status: 'وضعیت قبولی',
  actions: 'عملیات',
  editClass: 'ویرایش دوره',
  previewClass: 'پیشنمایش',
  unknown: 'نامشخص',
  unknownActivePeriod: 'بازه فعالسازیی مشخص نیست',
  courseTitle: 'عنوان دوره',
  finalGrade: 'نمره نهایی',
  currentPhase: 'فاز کنونی',
  classOverview: 'وضعیت کلی',
  show: 'مشاهده',
  before: 'قبل',
  after: 'بعد',
  targetGroup: 'گروه هدف',
  targetTime: 'نسبت به',
  offsetTime: 'زمان یاداوری',
  Participants: 'شرکت کنندگان',
  Instructor: 'مدرس',
  Manager: 'مسئول دوره',
  Teacher: 'مدرس',
  StartDatePhase: 'زمان شروع فاز',
  EndDatePhase: 'زمان پایان فاز',
  addReminder: 'افزودن یاداور',
  reminders: 'یاداور‌ها',
  messagePattern: 'پیام ارسالی',
  usePercentToGetOptions: 'برای دریافت گزینه های بیشتر از کلید ٪ استفاده کنید',
  classAdmin: 'مسئول دوره',
  edit: 'تغییر',
  setFinalResult: 'ثبت وضعیت نهایی برای افراد',
  submit: 'ثبت',
  reacalculationDone: 'محاسبه دوباره وضعیت قبولی انجام شد',
  basedOn: 'ثبت بر اساس',
  passMark: 'نمره قبولی',
  finalGradesSubmited: 'وضعیت نهایی ثبت شد',
  average: 'میانگین',
  addMembers: 'افزودن شرکت کننده',
  selectUsersToAdd: 'لطفا افراد مورد نظر را انتخاب کنید',
  nextPhase: 'فاز آتی',
  reAdd: 'افزودن دوباره به دوره',
  delete: 'حذف این دوره',
  userIsAlreadyAMember: 'کاربر هم اکنون عضو این دوره است',
  location: 'محل برگزاری',
  holdType: 'نحوه برگزاری',
  teacherName: 'مدرس',
  classDuration: 'بازه برگزاری کلاس (محاسبه به صورت خودکار با توجه به فاز‌ها)',
  enabledPhase: 'فعال',
  classDescription: 'توضیحات کلی دوره',
  myStatus: 'وضعیت قبولی',
  classPhases: 'مراحل دوره',
  phaseDuration: 'بازه فعال',
  userGrouping: 'گروه بندی کاربران',
  groupHint:
    'با تعریف گروه‌های مختلف می‌توانید زمانبندی مختلفی برای گروه های مختلف کاربران در فاز‌ها در نظر بگیرید',
  until: 'تا',
  group: 'گروه',
  notAddedToAnyGroupShort: 'شما هنوز عضو گروهی نشده اید',
  notAddedToAnyGroup:
    'شما در هیچ یک از گروه های این دوره اضافه نشده اید لطفا از مسئول دوره یا مسئول آموزش بخواید که شما رو به یک گروه اضافه کند',
  select: 'انتخاب',
  selectAGroup: 'انتخاب گروه',
  AllowChange: 'امکان انتخاب توسط شرکت کنندگان',
  groupSelectStartDate: 'زمان شروع انتخاب گروه',
  groupSelectEndDate: 'زمان پایان انتخاب گروه',
  groupChooseDescription: 'توضیحات برای پرسنل جهت انتخاب گروه',
  groupChooseReminderNotice:
    'در زمان شروع انتخاب گروه یک پیامک حاوی لینک به سامانه جهت انتخاب گروه برای اعضای دوره ارسال می‌شود',
  allowChoseGroupByParticipants: 'امکان انتخاب گروه توسط شرکت کنندگان در دوره',
  presence: 'وضعیت حضور',
  Present: 'حاضر',
  Absent: 'غایب',
  noActivePhaseFound: 'این دوره دارای فاز فعالی نیست',
  classStatus: 'وضعیت دوره‌ها',
  selectUsersToShowOverview: 'لطفا یک کاربر انتخاب کنید',
  termOverview: 'کارنامه پرسنل',
  termTranscript: 'کارنامه',
  termTranscriptExcel: 'خروجی اکسل',
  termId: 'شناسنامه آموزشی',
  limitViewToPresentMembers: 'فاز فقط به افراد حاضر نشان داده شود',
  showCorrectAnswers: 'نمایش گزینه‌های درست به کاربر پس از ارسال آزمون',
  limitViewToFillSurveyForPart:
    'محدودیت نمایش فاز در صورتی که پرسشنامه فاز زیر تکمیل نشده باشد',
  phaseLimitToPresntMember:
    'محتوای این فاز تنها برای افراد با وضعیت حاضر قابل مشاهده است',
  loading: 'در حال دریافت اطلاعات',
  sendMessageToParticipants: 'ارسال پیام به شرکت کنندگان',
  recalculateApproveState: 'محاسبه دوباره وضعیت قبولی',
  filterByEndDate: 'فیلتر بر اساس تاریخ اتمام دوره',
  entireOrganization: 'کل سازمان',
  showTopicTags: 'نمایش دسته بندی دوره‌ها',
  showDetails: 'نمایش جزئیات',
  showOnlyApprovedCourses: 'فقط دوره های قبول شده',
  classGrades: 'نمایش نمرات / امتیازات',
  setGlobalStartDate: 'زمان شروع دوره‌ها',
  categorize: 'دسته بندی دوره‌ها',
  grade: 'نمره',
  confirmRecalculateApproveState: (score: number) =>
    `وضعیت شرکت کنندگان دوره بر اساس حداقل نمری قبولی ${convertNumbersToProperFormat(score)} ثبت خواهد شود `,
  recalculationDisabled:
    'لطفا در تنظیمات دوره فاز مورد نظر وحداقل نمره قبولی را مشخص کنید',
  allParticipents: 'همه شرکت کنندگان',
  messageToUsers: 'متن پیام ارسالی',
  sendMessage: 'ارسال پیام',
  percent: '٪',
  averageGrade: 'میانگین نمره',
  percentEn: '%',
  fastSchedule: 'برنامه ریزی سریع',
  setSchedule: 'ثبت زمانبندی',
  phaseDurations: 'بازه زمانی فاز‌های مختلف را مشخص کنید',
  groupStartTimes: 'زمان شروع دوره برای هر گروه را مشخص کنید',
  groupTitle: 'عنوان گروه',
  unknownGroup: 'گروه نامشخص',
  hideAdvancedOptoins: 'پنهان کردن تنظیمات پیشرفته',
  showAdvancedOptions: 'نمایش تنظیمات پیشرفته',
  saved: 'دوره ذخیره شد',
  timing: 'زمانبندی',
  addGroup: 'افزودن گروه',
  listMonth: 'لیست ماهانه',
  allDay: 'کل روز',
  calendar: 'تقویم آموزشی',
  year: 'سال',
  listYear: 'لیست سالانه',
  print: 'چاپ',
  instructorHint:
    'مسئول دوره امکان کنترل کامل این دوره از قبیل زمانبندی، شرکت کنندگان، امتیازات و ... را داراست. همچنین مسئول آموزش کنترل کامل بر تمام دوره‌ها دارد.',
  classDeleted: 'دوره حذف شد',
  deleted: 'حذف شده',
  showDeleted: 'نمایش دوره‌های حذف شده',
  restore: 'بازگردانی دوره' + '',
  classRestored: 'دوره بازگردانی شد',
  basicSetting: 'تنظیمات پایه',
  phaseSteps: 'مراحل دوره',
  addStage: 'افزودن مرحله',
  limitStateToOne: 'در هر دوره فقط یک فاز با این نوع ساخته شود',
  includeInCorrective: 'نمایش در دوره اصلاحی',
  phaseWithGrade: 'فاز دارای نمره',
  otherStage: 'سایر مراحل',
  budget: 'بودجه دوره',
  currency: 'ریال',
  trainingHour: 'ساعت آموزشی',
  hour: 'ساعت',
  total: 'وضعیت کلی',
  filter: 'فیلتر',
  filterDistrict: 'فیلتر بخش',
  filterPost: 'فیلتر سمت',
  title: 'عنوان',
  corrective: 'اصلاحی',
  period: 'بازه',
  classes: 'دوره‌ها',
  totalTrainingHour: 'مجموع زمان دوره‌های آموزشی',
  totalTrainingHourDescription:
    'مجموع ساعت آموزشی برای دوره های برگزار شده / برنامه ریزی شده در این سال',
  totalBudget: 'مجموع بودجه',
  district: 'بخش',
  totalBudgetDescription:
    'مجموع بودجه کلاس های برگزار شده / برنامه ریزی شده در این سال',
  allRelatedUsers: 'کل گروه هدف',
  hourPerRelatedUser: 'سرانه ساعت آموزشی',
  hourPerRelatedUserDescription:
    'مجموع نفر ساعت آموزشی با توجه به حضور افراد تقسیم بر تعداد افرادی که حداقل عضو یک کلاس آموزشی بوده اند',
  totalPersonTrainingHour: 'مجموع نفر ساعت آموزشی',
  person: 'نفر',
  personHour: 'نفر ساعت',
  costPerRelatedUser: 'سرانه هزینه آموزشی',
  costPerRelatedUserDescription:
    'مجموع هزینه کلاس های آموزشی تقسیم بر تعداد افرادی که عضو حداقل یک دوره آموزشی بوده‌اند.',
  markAllRemainingAsPresent: 'ثبت همه افراد باقیمانده در لیست به عنوان حاضر',
  markAllRemainingAsAbsent: 'ثبت همه افراد باقیمانده در لیست به عنوان غایب',
  markAllUsersWithContribution: 'ثبت حضوری افراد بر اساس مشارکت',
  markThoseWithDeclaredStatus:
    'فقط روی مواردی که وضعیت حضور ثبت نشده اعمال شود',
  surveyTagFilterOptions: 'فیلتر پاسخ پرسشنامه‌های این فاز',
  None: 'بدون فیلتر',
  ClassAndPhase: 'پاسخ مرتبط با دوره و فاز',
  ClassAndPhaseAndStage: 'پاسخ های مرتبط با دوره و فاز و مرحله',
  roles: 'سمت ها',
  createCorrectiveClass: 'ساخت دوره اصلاحی',
  comma: ',',
  correectiveClassHint:
    'با ساخت دوره اصلاحی افرادی که در این دوره رد شده اند به صورت خودکار به دوره اضافه می‌شوند.',
  isClassCorrective: 'ایا دوره اصلاحی است؟',
  selectedDistricts: 'بخش‌‌های مورد نظر',
  batchMode: 'خروجی گروهی',
  selectedPosts: 'سمت‌های مورد نظر',
  getResults: 'دریافت کارنامه',
  name: 'نام و نام خانوادگی',
  ExportExcell: 'خروجی اکسل',
  addedInPhase: 'درخواست توسط',
  noClass: 'عدم تخصیص دوره',
  showMore: 'نمایش بیشتر',
  active: 'فعال',
  autoApproveAfterExam: 'ثبت خودکار وضعیت قبولی',
  approvedGrade: 'نمره قبولی (درصد)',
  gradingBasedOn: 'بر اساس فاز:',
  messageHint:
    'عنوان دوره و لینک ورود به دوره به صورت خودکار در پیام ارسال خواهد شد',
  autoGradingHint:
    'امتیاز دهی به صورت خودکار پس از پایان فاز انتخابی و بر اساس نمره قبولی انجام خواهد شد.',
  changeGroup: 'تغییر گروه',
  setGroup: 'انتخاب گروه',
  notAllowd: 'ثبت فقط توسط مسئول کلاس',
  IfNotSelected: 'تنها در صورتی که برای فرد ثبت نشده باشد',
  classStartEnd: 'بازه زمانی',
  employeeId: 'کد پرسنلی',
  teacherHint:
    'مدرس دوره دسترسی به این دوره ندارد و تنها پیامک ها برای آن ارسال می شود',
  confirmChanges: 'اعمال تغییرات',
  all: 'همه',
  submitBaseonContribution: 'ثبت بر اساس شرکت در',
  minute: 'دقیقه',
  changesAreNotSaved: 'تغییرات شما ذخیره نشده است آیا مطمن هستید؟',
  classDefalut: 'پیشفرض دوره',
  roleUserEditingPermission:
    'سمت یا افرادی که امکان مشاهده این بخش و مدیریت آن را دارند (با تکمیل این بخش دسترسی شرکت کنندگان به این بخش برداشته خواهد شد)',
  setForPersonsWithoutGroupOrInFuture:
    'ثبت برای افرادی که موعد آزمون آنها فرا نرسیده یا گروهی انتخاب نکرده اند',
  createClass: 'ساخت دوره',
  selectAll: 'انتخاب همه',
  createAClass: 'ساخت دوره جدید',
  thereIsClassWithSameName: 'یک کلاس با عنوان مشابه وجود دارد',
  selectParticipants: 'انتخاب فرد',
  allRelatedUsersDescription:
    'تعداد افرادی که حداقل در یک دوره شرکت کرده اند یا برنامه ریزی شده که شرکت کنند ',
  totalPersonTrainingHourDescription:
    'محموع نفر ساعت آموزشی با توجه به حضور و غیاب افراد',
  excelExport: 'دریافت خروجی اکسل',
  courseAnalytics: 'امار دوره‌ها',
  filterParticipants: 'فیلتر فرد',
  filterByTopic: 'فیلتر سرفصل',
  selectTitle: 'انتخاب سرفصل',
  addMemberToCourses: 'افزودن فرد به دوره ها',
  selectUser: 'انتخاب فرد',
  courseStatus: 'عضویت در دوره',
  coursePeriod: 'زمانبندی',
  courseBaseTime: 'تاریخ مبنا',
  courseStartDate: 'تاریخ شروع',
  courseEndDate: ' تاریخ اتمام کلاس',
  stage: 'مرحله',
  savedSuccessfully: 'تغییرات ذخیره شد.',
  errorSaving: 'مشکلی در ذخیره اطلاعات پیش آمده است .',
  userAlreadyParticipant: 'کاربر در حال حاضر شرکت کننده کلاس است.',
  phaseStartDateIsAfterEndDate:
    'تاریخ شروع فاز بعد از تاریخ پایان آن است ( تاریخ پایان فاز در صورت تعریف شروع فاز باید تعیین شود)',
  participantStatus: 'وضعیت',
  mandatoryCourse: 'نوع کلاس :‌اجباری',
  optionalCourse: 'نوع کلاس :‌اختیاری',
  phases: 'جزییات زمانبندی فازها',
  selectGroup: 'انتخاب گروه',
  resetCustomTime: 'بازنشانی زمان‌های شخصی',
  willBeReset:
    'تمام تنظیمات شخصی سازی شده ریست خواهد شد آیا از انجام این عملیات مطمن هستید؟',
  customTimeTitle: 'ثبت زمانبندی اختصاصی ',
  customTimeTitleFor: 'ثبت زمانبندی اختصاصی ',
  courseAddedSuccessfully: 'دوره(های) جدید با موفقیت افزوده شد.',
  showAllClasses: 'نمایش همه کلاس ها',

  getParticipantStatus: (
    status: 'Attended' | 'Approved' | 'Rejected' | 'Dropped'
  ) => {
    return status === 'Attended'
      ? 'در حال شرکت'
      : status === 'Approved'
        ? 'قبول شده'
        : status === 'Rejected'
          ? 'رد شده'
          : status === 'Dropped'
            ? 'حذف شده'
            : 'عدم عضویت';
  },

  membersAdded: (count: number) => {
    return `${convertDigitToProperFormat(count)} به این دوره اضافه شدند`;
  },

  rejectMember(name: string) {
    return `ایا از حذف «${name}» مطمئن هستید؟`;
  },
  reAddtMember(name: string) {
    return `ایا از بازگردانی «${name}» مطمئن هستید؟`;
  },
  getTimeOffsetMessage(number: number) {
    const tail = number < 0 ? this.before : this.after;
    number = Math.abs(number);
    if (number === 0) {
      return 'در هنگام';
    }
    if (number % 60 === 0) {
      if (number % (60 * 24) === 0) {
        const day = number / (60 * 24);
        return convertDigitToProperFormat(`${day} روز ${tail}`);
      }
      const hour = number / 60;
      return convertDigitToProperFormat(`${hour} ساعت ${tail}`);
    }
    return convertDigitToProperFormat(`${number} دقیقه ${tail}`);
  },
  remindercount(reminders: number | undefined) {
    const lang = getLanguageBaseOnTZ();
    if (lang === 'fa')
      return `${reminders ? convertDigitToProperFormat(reminders) : 'بدون'} یاداور`;
    else
      return `${reminders ? convertDigitToProperFormat(reminders) : 'No'} reminder`;
  },
  removeGroup(foundParticipant: number, title: string) {
    return ` ${foundParticipant} نفر در گروه ${title} عضو شده اند ایا مطمئن هستید که می‌خواهید این گروه حذف شود؟`;
  },
  groupCount(length: number) {
    return `${convertDigitToProperFormat(length)} گروه`;
  },
  memberCount(number: number) {
    return `${convertDigitToProperFormat(number)} عضو`;
  },
  pleaseReturnInSelectedPeriod(duration: string) {
    return `لطفا در بازه ${duration} جهت انتخاب گروه از همین صفحه اقدام نماید`;
  },
  noGroupNotice(smartDateDuration1: string) {
    return `شما جزو شرکت کنندگان این دوره هستید اما در هیچ گروهی از این دوره عضو نشده اید لطفا طی بازه‌ی ${smartDateDuration1} از طریق دکمه زیر گروه خود را انتخاب کنید`;
  },
  notInAnyGroup(length: number) {
    if (!length) return '';
    return `${convertDigitToProperFormat(length)} نفر از اعضای دوره در هیچ گروهی عضو نیستند`;
  },
  notAccesibleDuToIncompletePhase(name: string) {
    return `دسترسی به این بخش به دلیل عدم تکمیل فاز ${name} غیر فعال است`;
  },
  sentTo(message: string) {
    return `پیام به ${convertDigitToProperFormat(message)} نفر ارسال شد`;
  },
  schedule(title: string, stage: number) {
    return `برنامه ریزی سریع دوره ${title} مرحله ${convertNumbersToProperFormat(stage)}`;
  },
  duration(text: string) {
    return `مدت ${text} (دقیقه)`;
  },
  groupStartTime(title: string) {
    return `زمان شروع ${title}`;
  },
  confirmDeleteClass(name: string, terms: string, restore: boolean) {
    return `آیا از ${restore ? 'بازگردانی' : 'حذف'} دوره «${name}» برای تمام گروه‌های «${terms}» مطمئن هستید`;
  },
  persons(presentMembers: number) {
    return `${convertNumbersToProperFormat(presentMembers)} نفر`;
  },
  personsEn(presentMembers: number) {
    return `${presentMembers} نفر`;
  },
  terms(presentMembers: number) {
    return `${convertNumbersToProperFormat(presentMembers)} دوره`;
  },
  termsEn(presentMembers: string) {
    return `${presentMembers} دوره`;
  },
  present(p: number, activeMembers: number) {
    return `${convertNumbersToProperFormat(p)} نفر حاضر از ${convertNumbersToProperFormat(activeMembers)} نفر `;
  },
  stageNumber(number: number) {
    return `مرحله ${convertNumbersToProperFormat(number)}`;
  },
  createNewCorrectiveClass(name: string) {
    return `ساخت دوره اصلاحی جدید ${name}`;
  },
  useClassSharedWith(
    isCorrective: boolean,
    groupNames: string[],
    classId: number
  ) {
    return `استفاده از دوره ${isCorrective ? '(اصلاحی) ' : ''}مشترک با ${groupNames.join(', ')} : (${convertNumbersToProperFormat(classId)})`;
  },
  usersAddedToCorrectiveClass(foundUsers: string, topic: string) {
    return `${foundUsers} به دوره اصلاحی ${topic} اضافه شدند`;
  },
  getResultsFor(length: number) {
    return ` مشاهده کارنامه ${convertNumbersToProperFormat(length)} نفر`;
  },
  classOutput(
    name: string,
    corrective: undefined | boolean,
    startDate: number | undefined,
    termnames: string
  ) {
    const s = `دوره ${name}${corrective ? ` (${this.corrective})` : ''} ${startDate ? convertDigitToProperFormat(moment(startDate).format('jYYYY')) : ''} گروه ${termnames} `;
    return s.slice(0, 150);
  },
  calendarOutputTerm(term: Term) {
    return `تقویم گروه ${term.properties.name} - ${convertDigitToProperFormat(moment(term.startDate).format('jYYYY'))}`;
  },
  calenderOutput(year: number) {
    return `تقویم ${convertNumbersToProperFormat(year)}`;
  },
  calenderOutputStr(year?: string) {
    return `تقویم ${year}`;
  },
  report(name: string, year: string, reportType: string) {
    return `${reportType} ${name} ${convertDigitToProperFormat(year)}`;
  },
  reportGroup(
    districts: string,
    posts: string,
    year: string,
    termName: string,
    reportType: string
  ) {
    let ret = reportType;
    ret += ` گروه ${termName}`;
    if (posts.length) ret += ' (' + posts + ')';
    if (districts.length) ret += ' (' + districts + ')';
    ret += ' ' + convertDigitToProperFormat(year);
    return ret;
  },
  rejectedPDPIn(rejectedPhaseName: string | undefined, byUser: string) {
    return `عدم تایید توسط ${byUser} در مرحله ${rejectedPhaseName}`;
  },
  showingPersons(count: number, from: number) {
    return `نمایش ${convertNumbersToProperFormat(count)} کارنامه از ${convertNumbersToProperFormat(from)} نفر`;
  },

  // District Analytics Descriptions
  districtDescription:
    'نام بخش یا منطقه سازمانی که کارکنان در آن مشغول به کار هستند',
  totalBudgetDistrictDescription:
    'مجموع بودجه اختصاص یافته به دوره‌های آموزشی این بخش بر اساس تعداد شرکت‌کنندگان از این بخش',
  totalTrainingHourDistrictDescription:
    'مجموع ساعات آموزشی دوره‌هایی که حداقل یک نفر از این بخش در آن شرکت کرده است',
  allRelatedUsersDistrictDescription:
    'تعداد کل افرادی از این بخش که در دوره‌های آموزشی شرکت کرده‌اند یا قرار است شرکت کنند',
  totalPersonTrainingHourDistrictDescription:
    'مجموع نفر-ساعت آموزشی محاسبه شده بر اساس حضور واقعی افراد این بخش در دوره‌ها',
  hourPerRelatedUserDistrictDescription:
    'میانگین ساعات آموزشی هر فرد از این بخش (مجموع نفر-ساعت تقسیم بر تعداد شرکت‌کنندگان)',
  costPerRelatedUserDistrictDescription:
    'میانگین هزینه آموزشی هر فرد از این بخش (مجموع بودجه تقسیم بر تعداد شرکت‌کنندگان)',
  errorCreatingClass(name: string) {
    return `خطا در ساخت کلاس ${name}`;
  },
};
